import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { DocumentBundleAccessBatchesView } from '../components/views/documentBundleAccessView'

// Sentinel-admin only. The view's first API call (/document-access-log-batches)
// re-checks `isAdminUser` server-side and a 403 bounces the user to /home, so
// no separate auth probe is needed here (same approach as cronScrapers.tsx).
function DocumentBundleAccessBatches() {
    return (
        <div className="documentBundleAccessBatches">
            <Sidebar />
            <MainView>
                <ViewTitle text="Bundle Access Log" />
                <DocumentBundleAccessBatchesView />
            </MainView>
        </div>
    )
}

export default DocumentBundleAccessBatches
